import React from 'react';

import { sortByStringValue } from '~/utils/array';

import { SharedGridProps } from '../../../types/SharedGridProps';
import { ContentContainer } from '../../ContentContainer/ContentContainer';
import { Grid } from '../../Grid/Grid';

export const CardsGrid = ({
  gridOptions,
  isLoading,
  cards,
  renderItem,
}: {
  gridOptions: SharedGridProps;
  cards: any[];
  isLoading?: boolean;
  renderItem: (item: any) => React.ReactNode;
}) => {
  const sortedCards = [...cards].sort(sortByStringValue('label'));

  return (
    <ContentContainer loadingContent={{ isLoading }}>
      <Grid columnSpacing={4} rowSpacing={4} {...gridOptions}>
        {sortedCards.map((card, index) => {
          const key = card.id ?? card.name ?? index;
          return <React.Fragment key={key}>{renderItem(card)}</React.Fragment>;
        })}
      </Grid>
    </ContentContainer>
  );
};
